import { HIDDEN_AUDIO_MODE_KEYS } from "./constants";

export const SHUFFLE_MOODS = [
  {
    name: "Lo-fi study",
    emoji: "📚",
    slowControl: 0.85,
    reverbAmount: 0.4,
    lowPassMode: true,
    lowPassCutoff: 1200,
    lofiTapeMode: true,
    lofiHissVolume: 0.6,
    bitcrusherMode: true,
    bitcrusherAmount: 0.5,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.4,
    rainyMode: true,
    rainVolume: 0.45,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Late night",
    emoji: "🌙",
    slowControl: 0.78,
    reverbAmount: 0.6,
    bassBoostMode: true,
    bassBoostAmount: 0.55,
    lowPassMode: false,
    lofiTapeMode: true,
    lofiHissVolume: 0.7,
    rainyMode: false,
    coffeeShopMode: true,
    coffeeShopVolume: 0.5,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Dreamy wash",
    emoji: "☁️",
    slowControl: 0.7,
    reverbAmount: 0.85,
    lowPassMode: true,
    lowPassCutoff: 900,
    highPassMode: true,
    highPassCutoff: 320,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Chill rain",
    emoji: "🌧️",
    slowControl: 0.82,
    reverbAmount: 0.5,
    lowPassMode: false,
    lofiTapeMode: false,
    rainyMode: true,
    rainVolume: 0.7,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Morning cafe",
    emoji: "☕",
    slowControl: 0.9,
    reverbAmount: 0.3,
    lowPassMode: false,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: true,
    coffeeShopVolume: 0.55,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Vaporwave",
    emoji: "🌴",
    slowControl: 0.72,
    reverbAmount: 0.7,
    lowPassMode: true,
    lowPassCutoff: 1100,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: "vaporwave",
  },
  {
    name: "Brainrot",
    emoji: "🧠",
    slowControl: 0.75,
    reverbAmount: 0.55,
    lowPassMode: false,
    lofiTapeMode: true,
    lofiHissVolume: 0.4,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: "brainrot",
  },
  {
    name: "Noir cafe",
    emoji: "🎬",
    slowControl: 0.85,
    reverbAmount: 0.45,
    lowPassMode: false,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: true,
    coffeeShopVolume: 0.5,
    preservePitchMode: false,
    videoFx: "noir-film",
  },
  {
    name: "Sunset drive",
    emoji: "🌅",
    slowControl: 0.88,
    reverbAmount: 0.35,
    bassBoostMode: true,
    bassBoostAmount: 0.6,
    lowPassMode: false,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Underwater",
    emoji: "🌊",
    slowControl: 0.68,
    reverbAmount: 0.9,
    lowPassMode: true,
    lowPassCutoff: 750,
    bassBoostMode: true,
    bassBoostAmount: 0.65,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Tape decay",
    emoji: "📼",
    slowControl: 0.8,
    reverbAmount: 0.5,
    lowPassMode: true,
    lowPassCutoff: 1400,
    lofiTapeMode: true,
    lofiHissVolume: 0.85,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.55,
    bitcrusherMode: true,
    bitcrusherAmount: 0.4,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "3 AM thoughts",
    emoji: "🌌",
    slowControl: 0.72,
    reverbAmount: 0.75,
    lowPassMode: true,
    lowPassCutoff: 1000,
    lofiTapeMode: true,
    lofiHissVolume: 0.5,
    rainyMode: true,
    rainVolume: 0.5,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Ethereal",
    emoji: "✨",
    slowControl: 0.65,
    reverbAmount: 0.95,
    lowPassMode: false,
    highPassMode: true,
    highPassCutoff: 400,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Slow burn",
    emoji: "🔥",
    slowControl: 0.83,
    reverbAmount: 0.55,
    bassBoostMode: true,
    bassBoostAmount: 0.5,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.45,
    lowPassMode: false,
    lofiTapeMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Cozy bedroom",
    emoji: "🛏️",
    slowControl: 0.87,
    reverbAmount: 0.4,
    lowPassMode: true,
    lowPassCutoff: 1300,
    lofiTapeMode: true,
    lofiHissVolume: 0.5,
    rainyMode: true,
    rainVolume: 0.4,
    coffeeShopMode: false,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Ghost radio",
    emoji: "📻",
    slowControl: 0.78,
    reverbAmount: 0.65,
    lowPassMode: true,
    lowPassCutoff: 1100,
    highPassMode: true,
    highPassCutoff: 280,
    lofiTapeMode: true,
    lofiHissVolume: 0.7,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.6,
    bitcrusherMode: true,
    bitcrusherAmount: 0.55,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Snowfall",
    emoji: "❄️",
    slowControl: 0.8,
    reverbAmount: 0.7,
    lowPassMode: true,
    lowPassCutoff: 1000,
    lofiTapeMode: true,
    lofiHissVolume: 0.5,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Bookstore",
    emoji: "📖",
    slowControl: 0.9,
    reverbAmount: 0.35,
    coffeeShopMode: true,
    coffeeShopVolume: 0.55,
    lofiTapeMode: true,
    lofiHissVolume: 0.4,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Train ride",
    emoji: "🚆",
    slowControl: 0.86,
    reverbAmount: 0.45,
    bassBoostMode: true,
    bassBoostAmount: 0.5,
    rainyMode: true,
    rainVolume: 0.55,
    lofiTapeMode: true,
    lofiHissVolume: 0.5,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Library",
    emoji: "🏛️",
    slowControl: 0.92,
    reverbAmount: 0.3,
    lowPassMode: true,
    lowPassCutoff: 1300,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Sunday",
    emoji: "🥐",
    slowControl: 0.92,
    reverbAmount: 0.3,
    coffeeShopMode: true,
    coffeeShopVolume: 0.45,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Stargazing",
    emoji: "⭐",
    slowControl: 0.7,
    reverbAmount: 0.9,
    lowPassMode: true,
    lowPassCutoff: 950,
    highPassMode: true,
    highPassCutoff: 280,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Heartbreak",
    emoji: "💔",
    slowControl: 0.74,
    reverbAmount: 0.8,
    lofiTapeMode: true,
    lofiHissVolume: 0.6,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.5,
    rainyMode: true,
    rainVolume: 0.4,
    videoFx: null,
  },
  {
    name: "Old film",
    emoji: "🎞️",
    slowControl: 0.82,
    reverbAmount: 0.5,
    lofiTapeMode: true,
    lofiHissVolume: 0.8,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.7,
    bitcrusherMode: true,
    bitcrusherAmount: 0.6,
    lowPassMode: true,
    lowPassCutoff: 1500,
    videoFx: null,
  },
  {
    name: "Oldies playing",
    emoji: "📻",
    slowControl: 0.78,
    reverbAmount: 0.62,
    lowPassMode: true,
    lowPassCutoff: 1050,
    highPassMode: true,
    highPassCutoff: 260,
    lofiTapeMode: true,
    lofiHissVolume: 0.72,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.65,
    bitcrusherMode: true,
    bitcrusherAmount: 0.46,
    phaserMode: true,
    phaserAmount: 0.32,
    bassBoostMode: false,
    rainyMode: false,
    coffeeShopMode: false,
    preservePitchMode: false,
    videoFx: "noir-film",
  },
  {
    name: "Foggy morning",
    emoji: "🌁",
    slowControl: 0.85,
    reverbAmount: 0.6,
    lowPassMode: true,
    lowPassCutoff: 850,
    coffeeShopMode: true,
    coffeeShopVolume: 0.4,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Headphone glow",
    emoji: "🎧",
    slowControl: 0.83,
    reverbAmount: 0.55,
    bassBoostMode: true,
    bassBoostAmount: 0.65,
    lofiTapeMode: true,
    lofiHissVolume: 0.4,
    videoFx: null,
  },
  {
    name: "Hotel lobby",
    emoji: "🛎️",
    slowControl: 0.88,
    reverbAmount: 0.5,
    coffeeShopMode: true,
    coffeeShopVolume: 0.5,
    lofiTapeMode: true,
    lofiHissVolume: 0.35,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Echo cave",
    emoji: "🏔️",
    slowControl: 0.72,
    reverbAmount: 0.8,
    echoMode: true,
    echoAmount: 0.7,
    lowPassMode: true,
    lowPassCutoff: 900,
    bassBoostMode: true,
    bassBoostAmount: 0.5,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Shimmer",
    emoji: "🎵",
    slowControl: 0.76,
    reverbAmount: 0.7,
    highPassMode: true,
    highPassCutoff: 300,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Space drift",
    emoji: "🚀",
    slowControl: 0.68,
    reverbAmount: 0.88,
    echoMode: true,
    echoAmount: 0.55,
    highPassMode: true,
    highPassCutoff: 350,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Vintage hall",
    emoji: "🎻",
    slowControl: 0.83,
    reverbAmount: 0.5,
    echoMode: true,
    echoAmount: 0.45,
    lofiTapeMode: true,
    lofiHissVolume: 0.5,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.4,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Midnight signal",
    emoji: "📡",
    slowControl: 0.79,
    reverbAmount: 0.55,
    echoMode: true,
    echoAmount: 0.6,
    phaserMode: true,
    phaserAmount: 0.4,
    lofiTapeMode: true,
    lofiHissVolume: 0.45,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Lush forest",
    emoji: "🌿",
    slowControl: 0.84,
    reverbAmount: 0.6,
    rainyMode: true,
    rainVolume: 0.45,
    lowPassMode: true,
    lowPassCutoff: 1200,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Shoreline",
    emoji: "🏖️",
    slowControl: 0.86,
    reverbAmount: 0.45,
    seashoreMode: true,
    seashoreVolume: 0.5,
    lowPassMode: true,
    lowPassCutoff: 1300,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Tide pool",
    emoji: "🐚",
    slowControl: 0.74,
    reverbAmount: 0.75,
    seashoreMode: true,
    seashoreVolume: 0.4,
    echoMode: true,
    echoAmount: 0.5,
    highPassMode: true,
    highPassCutoff: 320,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Sunrise swim",
    emoji: "🌅",
    slowControl: 0.9,
    reverbAmount: 0.35,
    seashoreMode: true,
    seashoreVolume: 0.35,
    lofiTapeMode: true,
    lofiHissVolume: 0.3,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Queue outside",
    emoji: "🖤",
    slowControl: 0.8,
    reverbAmount: 0.4,
    berghainMode: true,
    berghainVolume: 0.5,
    // Muffled like hearing the room from the pavement.
    lowPassMode: true,
    lowPassCutoff: 750,
    bassBoostMode: true,
    bassBoostAmount: 0.65,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "After hours",
    emoji: "🔊",
    slowControl: 0.92,
    reverbAmount: 0.55,
    berghainMode: true,
    berghainVolume: 0.4,
    bassBoostMode: true,
    bassBoostAmount: 0.5,
    phaserMode: true,
    phaserAmount: 0.35,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Lounge piano",
    emoji: "🎹",
    slowControl: 0.87,
    reverbAmount: 0.55,
    hotelLoungeMode: true,
    hotelLoungeVolume: 0.45,
    lofiTapeMode: true,
    lofiHissVolume: 0.3,
    preservePitchMode: true,
    videoFx: null,
  },
  {
    name: "Marble lobby",
    emoji: "🏛️",
    slowControl: 0.82,
    reverbAmount: 0.72,
    hotelLoungeMode: true,
    hotelLoungeVolume: 0.35,
    echoMode: true,
    echoAmount: 0.4,
    highPassMode: true,
    highPassCutoff: 280,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Negroni hour",
    emoji: "🍸",
    slowControl: 0.85,
    reverbAmount: 0.5,
    cocktailBarMode: true,
    cocktailBarVolume: 0.45,
    vinylCrackleMode: true,
    vinylCrackleVolume: 0.45,
    bassBoostMode: true,
    bassBoostAmount: 0.4,
    preservePitchMode: false,
    videoFx: null,
  },
  {
    name: "Neon booth",
    emoji: "🌃",
    slowControl: 0.76,
    reverbAmount: 0.65,
    cocktailBarMode: true,
    cocktailBarVolume: 0.35,
    phaserMode: true,
    phaserAmount: 0.55,
    lofiTapeMode: true,
    lofiHissVolume: 0.4,
    preservePitchMode: false,
    videoFx: "vaporwave",
  },
];

export const POPULAR_MOOD_NAMES = [
  "Oldies playing",
  "Lo-fi study",
  "Chill rain",
  "Cozy bedroom",
  "Late night",
  "Dreamy wash",
  "Morning cafe",
  "Sunset drive",
  "Vaporwave",
  "Tape decay",
  "3 AM thoughts",
  "Underwater",
  "Ethereal",
  "Snowfall",
  "Ghost radio",
  "Noir cafe",
  "Stargazing",
  "Slow burn",
  "Bookstore",
  "Train ride",
  "Headphone glow",
  "Foggy morning",
  "Space drift",
  "Midnight signal",
  "Lush forest",
  "Old film",
  "Shoreline",
  "Tide pool",
  "Sunrise swim",
  "Lounge piano",
  "Marble lobby",
  "Negroni hour",
  "Neon booth",
  "Queue outside",
  "After hours",
];

// A mood that switches on a parked ambience would apply a bed with no sample
// to play, so it stays out of the list until its loop ships — the same
// HIDDEN_AUDIO_MODE_KEYS gate the tiles use. Removing a key there brings both
// the tile and its moods back.
const PARKED_MOOD_FIELDS = {
  hotelLounge: "hotelLoungeMode",
  cocktailBar: "cocktailBarMode",
  seashore: "seashoreMode",
  berghain: "berghainMode",
  rainy: "rainyMode",
  coffeeShop: "coffeeShopMode",
};

function usesParkedAmbience(mood) {
  return HIDDEN_AUDIO_MODE_KEYS.some(
    (key) => PARKED_MOOD_FIELDS[key] && mood[PARKED_MOOD_FIELDS[key]] === true,
  );
}

export function getPopularMoods() {
  return POPULAR_MOOD_NAMES.map((name) => getMoodByName(name))
    .filter(Boolean)
    .filter((mood) => !usesParkedAmbience(mood));
}

export function pickRandomMood() {
  return SHUFFLE_MOODS[Math.floor(Math.random() * SHUFFLE_MOODS.length)];
}

export function getMoodByName(name) {
  return SHUFFLE_MOODS.find((v) => v.name === name) || null;
}

// Moods that feel right for each hour band. The first name in each
// list is the strongest pick (always pinned as one of the suggestions).
const HOUR_BAND_MOODS = {
  lateNight: [
    "3 AM thoughts",
    "Cozy bedroom",
    "Ghost radio",
    "Late night",
    "After hours",
  ],
  morning: ["Morning cafe", "Lo-fi study", "Dreamy wash", "Sunrise swim"],
  day: ["Lo-fi study", "Chill rain", "Vaporwave", "Ethereal", "Shoreline"],
  evening: ["Sunset drive", "Noir cafe", "Slow burn", "Negroni hour"],
  night: [
    "Late night",
    "Ghost radio",
    "Vaporwave",
    "Tape decay",
    "Neon booth",
  ],
};

function getHourBand(hour) {
  if (hour < 5) return "lateNight";
  if (hour < 10) return "morning";
  if (hour < 17) return "day";
  if (hour < 21) return "evening";
  return "night";
}

function shuffleWith(arr, rand) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function hashString(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

// Mulberry32 — small deterministic PRNG seeded from a 32-bit int.
function seededRandom(seed) {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function getSuggestedMoods(count = 4, now = new Date(), seed) {
  const band = getHourBand(now.getHours());
  const preferredNames = HOUR_BAND_MOODS[band] || [];
  const preferred = preferredNames
    .map((name) => getMoodByName(name))
    .filter(Boolean);

  // Always pin the top pick for this hour band so e.g. "3 AM thoughts"
  // is guaranteed visible after midnight.
  const result = preferred.length ? [preferred[0]] : [];

  // When given a seed (e.g. the current track name), use a deterministic
  // PRNG so the same song always yields the same suggested vibes.
  const seedStr =
    typeof seed === "string" && seed.trim() ? seed.trim() : "default-vibes";
  const rand = seededRandom(hashString(seedStr));

  const remaining = SHUFFLE_MOODS.filter((v) => !result.includes(v));
  shuffleWith(remaining, rand);
  for (const v of remaining) {
    if (result.length >= count) break;
    result.push(v);
  }

  // Shuffle final order so the pinned pick isn't always first.
  return shuffleWith(result, rand);
}

const MOOD_ADJECTIVES = [
  "Velvet", "Misty", "Neon", "Hazy", "Lush", "Dusty", "Soft", "Faded",
  "Glassy", "Drifting", "Smoky", "Crystal", "Amber", "Quiet", "Aurora",
  "Sleepy", "Honey", "Silver", "Plush", "Twilight", "Slow", "Pastel",
  "Vintage", "Cosmic", "Wistful", "Floating",
];
const MOOD_NOUNS = [
  "dream", "rain", "echo", "wave", "drift", "haze", "glow", "tide",
  "fog", "loop", "void", "spell", "mood", "trance", "lull", "drone",
  "afterglow", "halo", "nocturne", "bloom", "static", "current",
];
const MOOD_EMOJIS = [
  "✨", "💜", "🌙", "☁️", "🌌", "🌊", "🔮", "🪐", "🕯️", "🌸",
  "🎐", "💫", "🌫️", "🫧", "🌅", "🎴",
];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function rand(min, max) {
  return Math.random() * (max - min) + min;
}

function randTo(min, max, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(rand(min, max) * factor) / factor;
}

function randStep(min, max, step) {
  return Math.round(rand(min, max) / step) * step;
}

function chance(p) {
  return Math.random() < p;
}

// Ambient beds layer, so each is rolled independently. Kept individually
// unlikely so a generated mood rarely stacks them all at once.
function pickAmbientBeds() {
  return {
    rainy: chance(0.25),
    coffeeShop: chance(0.2),
    seashore: chance(0.15),
    berghain: chance(0.12),
    hotelLounge: chance(0.12),
    cocktailBar: chance(0.12),
  };
}

export function generateNewMood() {
  const ambientBeds = pickAmbientBeds();

  return {
    name: `${pick(MOOD_ADJECTIVES)} ${pick(MOOD_NOUNS)}`,
    emoji: pick(MOOD_EMOJIS),
    slowControl: randTo(0.65, 0.95, 2),
    reverbAmount: randTo(0.2, 0.9, 2),
    lowPassMode: chance(0.5),
    lowPassCutoff: randStep(700, 1500, 50),
    highPassMode: chance(0.25),
    highPassCutoff: randStep(200, 500, 20),
    bitcrusherMode: chance(0.3),
    bitcrusherAmount: randTo(0.3, 0.7, 2),
    bassBoostMode: chance(0.4),
    bassBoostAmount: randTo(0.3, 0.7, 2),
    phaserMode: chance(0.25),
    phaserAmount: randTo(0.25, 0.75, 2),
    echoMode: chance(0.3),
    echoAmount: randTo(0.3, 0.75, 2),
    lofiTapeMode: chance(0.5),
    lofiHissVolume: randTo(0.3, 0.8, 2),
    vinylCrackleMode: chance(0.35),
    vinylCrackleVolume: randTo(0.3, 0.6, 2),
    rainyMode: ambientBeds.rainy,
    rainVolume: randTo(0.3, 0.7, 2),
    coffeeShopMode: ambientBeds.coffeeShop,
    coffeeShopVolume: randTo(0.3, 0.6, 2),
    seashoreMode: ambientBeds.seashore,
    seashoreVolume: randTo(0.3, 0.6, 2),
    berghainMode: ambientBeds.berghain,
    berghainVolume: randTo(0.3, 0.6, 2),
    hotelLoungeMode: ambientBeds.hotelLounge,
    hotelLoungeVolume: randTo(0.3, 0.6, 2),
    cocktailBarMode: ambientBeds.cocktailBar,
    cocktailBarVolume: randTo(0.3, 0.6, 2),
    preservePitchMode: chance(0.25),
    videoFx: null,
  };
}


export function moodToPopupState(vibe) {
  return {
    isSlowedEnabled: true,
    slowControl: vibe.slowControl,
    reverbAmount: vibe.reverbAmount,
    lowPassMode: !!vibe.lowPassMode,
    lowPassCutoff:
      typeof vibe.lowPassCutoff === "number" ? vibe.lowPassCutoff : 1000,
    highPassMode: !!vibe.highPassMode,
    highPassCutoff:
      typeof vibe.highPassCutoff === "number" ? vibe.highPassCutoff : 500,
    bitcrusherMode: !!vibe.bitcrusherMode,
    bitcrusherAmount:
      typeof vibe.bitcrusherAmount === "number" ? vibe.bitcrusherAmount : 0.45,
    bassBoostMode: !!vibe.bassBoostMode,
    bassBoostAmount:
      typeof vibe.bassBoostAmount === "number" ? vibe.bassBoostAmount : 0.5,
    phaserMode: !!vibe.phaserMode,
    phaserAmount:
      typeof vibe.phaserAmount === "number" ? vibe.phaserAmount : 0.5,
    echoMode: !!vibe.echoMode,
    echoAmount: typeof vibe.echoAmount === "number" ? vibe.echoAmount : 0.5,
    lofiTapeMode: !!vibe.lofiTapeMode,
    lofiHissVolume:
      typeof vibe.lofiHissVolume === "number" ? vibe.lofiHissVolume : 1,
    rainyMode: !!vibe.rainyMode,
    rainVolume: typeof vibe.rainVolume === "number" ? vibe.rainVolume : 0.6,
    coffeeShopMode: !!vibe.coffeeShopMode,
    coffeeShopVolume:
      typeof vibe.coffeeShopVolume === "number" ? vibe.coffeeShopVolume : 0.6,
    seashoreMode: !!vibe.seashoreMode,
    seashoreVolume:
      typeof vibe.seashoreVolume === "number" ? vibe.seashoreVolume : 0.6,
    berghainMode: !!vibe.berghainMode,
    berghainVolume:
      typeof vibe.berghainVolume === "number" ? vibe.berghainVolume : 0.6,
    hotelLoungeMode: !!vibe.hotelLoungeMode,
    hotelLoungeVolume:
      typeof vibe.hotelLoungeVolume === "number" ? vibe.hotelLoungeVolume : 0.6,
    cocktailBarMode: !!vibe.cocktailBarMode,
    cocktailBarVolume:
      typeof vibe.cocktailBarVolume === "number" ? vibe.cocktailBarVolume : 0.6,
    vinylCrackleMode: !!vibe.vinylCrackleMode,
    vinylCrackleVolume:
      typeof vibe.vinylCrackleVolume === "number"
        ? vibe.vinylCrackleVolume
        : 0.55,
    preservePitchMode: !!vibe.preservePitchMode,
    videoFx: vibe.videoFx ?? null,
  };
}

// Fields applyMoodToTab always writes, so they always have to match.
const MOOD_MODE_FIELDS = [
  "lowPassMode",
  "highPassMode",
  "bitcrusherMode",
  "bassBoostMode",
  "phaserMode",
  "echoMode",
  "lofiTapeMode",
  "rainyMode",
  "coffeeShopMode",
  "seashoreMode",
  "berghainMode",
  "hotelLoungeMode",
  "cocktailBarMode",
  "vinylCrackleMode",
  "preservePitchMode",
];

// Fields applyMoodToTab only writes when the mood defines them: a mood that
// leaves one out inherits whatever the tab already had, so it cannot be part
// of the comparison.
const MOOD_AMOUNT_FIELDS = [
  "lowPassCutoff",
  "highPassCutoff",
  "bitcrusherAmount",
  "bassBoostAmount",
  "phaserAmount",
  "echoAmount",
  "lofiHissVolume",
  "rainVolume",
  "coffeeShopVolume",
  "seashoreVolume",
  "berghainVolume",
  "hotelLoungeVolume",
  "cocktailBarVolume",
  "vinylCrackleVolume",
];

export function moodMatchesState(mood, state) {
  if (!mood || !state) return false;
  if (state.slowControl !== mood.slowControl) return false;
  if (state.reverbAmount !== mood.reverbAmount) return false;
  if ((state.videoFx ?? null) !== (mood.videoFx ?? null)) return false;
  if (MOOD_MODE_FIELDS.some((field) => !!state[field] !== !!mood[field])) {
    return false;
  }
  return MOOD_AMOUNT_FIELDS.every(
    (field) =>
      typeof mood[field] !== "number" || state[field] === mood[field],
  );
}

/**
 * Which mood the tab is currently set to, derived from live content state
 * rather than remembered separately — so tweaking any control on top of a
 * mood correctly deselects it.
 */
export function findMoodByState(state, moods = getPopularMoods()) {
  if (!state) return null;
  return moods.find((mood) => moodMatchesState(mood, state))?.name || null;
}

/** Snapshot current popup/content state so a mood pick can be undone. */
export function popupStateToMood(state) {
  if (!state) return null;
  return {
    name: "__pre_mood__",
    slowControl:
      typeof state.slowControl === "number" ? state.slowControl : 1,
    reverbAmount:
      typeof state.reverbAmount === "number" ? state.reverbAmount : 0,
    lowPassMode: !!state.lowPassMode,
    lowPassCutoff:
      typeof state.lowPassCutoff === "number" ? state.lowPassCutoff : 1000,
    highPassMode: !!state.highPassMode,
    highPassCutoff:
      typeof state.highPassCutoff === "number" ? state.highPassCutoff : 500,
    bitcrusherMode: !!state.bitcrusherMode,
    bitcrusherAmount:
      typeof state.bitcrusherAmount === "number"
        ? state.bitcrusherAmount
        : 0.45,
    bassBoostMode: !!state.bassBoostMode,
    bassBoostAmount:
      typeof state.bassBoostAmount === "number" ? state.bassBoostAmount : 0.5,
    phaserMode: !!state.phaserMode,
    phaserAmount:
      typeof state.phaserAmount === "number" ? state.phaserAmount : 0.5,
    echoMode: !!state.echoMode,
    echoAmount: typeof state.echoAmount === "number" ? state.echoAmount : 0.5,
    lofiTapeMode: !!state.lofiTapeMode,
    lofiHissVolume:
      typeof state.lofiHissVolume === "number" ? state.lofiHissVolume : 1,
    rainyMode: !!state.rainyMode,
    rainVolume: typeof state.rainVolume === "number" ? state.rainVolume : 0.6,
    coffeeShopMode: !!state.coffeeShopMode,
    coffeeShopVolume:
      typeof state.coffeeShopVolume === "number"
        ? state.coffeeShopVolume
        : 0.6,
    seashoreMode: !!state.seashoreMode,
    seashoreVolume:
      typeof state.seashoreVolume === "number" ? state.seashoreVolume : 0.6,
    berghainMode: !!state.berghainMode,
    berghainVolume:
      typeof state.berghainVolume === "number" ? state.berghainVolume : 0.6,
    hotelLoungeMode: !!state.hotelLoungeMode,
    hotelLoungeVolume:
      typeof state.hotelLoungeVolume === "number"
        ? state.hotelLoungeVolume
        : 0.6,
    cocktailBarMode: !!state.cocktailBarMode,
    cocktailBarVolume:
      typeof state.cocktailBarVolume === "number"
        ? state.cocktailBarVolume
        : 0.6,
    vinylCrackleMode: !!state.vinylCrackleMode,
    vinylCrackleVolume:
      typeof state.vinylCrackleVolume === "number"
        ? state.vinylCrackleVolume
        : 0.55,
    preservePitchMode: !!state.preservePitchMode,
    videoFx: state.videoFx ?? null,
  };
}

async function sendTabCommand(sendMessageToTab, tabId, command, value) {
  try {
    return await sendMessageToTab(
      tabId,
      { command, data: { value } },
      { muteConnectionError: true },
    );
  } catch (_error) {
    return null;
  }
}

export async function applyMoodToTab(tabId, vibe, sendMessageToTab) {
  // popupStateToMood returns null when there is no content state to snapshot
  // (unsupported tab, or the content script never answered), so callers can
  // hand us nothing. Do not dereference it.
  if (!vibe) return null;
  let latest = null;
  const send = async (command, value) => {
    const response = await sendTabCommand(
      sendMessageToTab,
      tabId,
      command,
      value,
    );
    if (response) latest = response;
    return response;
  };

  await send("slowed-enable");
  await send("slow-control", vibe.slowControl);
  await send("reverb-amount", vibe.reverbAmount);
  if (typeof vibe.lowPassCutoff === "number") {
    await send("low-pass-cutoff", vibe.lowPassCutoff);
  }
  await send("low-pass-mode", !!vibe.lowPassMode);
  if (typeof vibe.highPassCutoff === "number") {
    await send("high-pass-cutoff", vibe.highPassCutoff);
  }
  await send("high-pass-mode", !!vibe.highPassMode);
  if (typeof vibe.bitcrusherAmount === "number") {
    await send("bitcrusher-amount", vibe.bitcrusherAmount);
  }
  await send("bitcrusher-mode", !!vibe.bitcrusherMode);
  if (typeof vibe.bassBoostAmount === "number") {
    await send("bass-boost-amount", vibe.bassBoostAmount);
  }
  await send("bass-boost-mode", !!vibe.bassBoostMode);
  if (typeof vibe.phaserAmount === "number") {
    await send("phaser-amount", vibe.phaserAmount);
  }
  await send("phaser-mode", !!vibe.phaserMode);
  if (typeof vibe.echoAmount === "number") {
    await send("echo-amount", vibe.echoAmount);
  }
  await send("echo-mode", !!vibe.echoMode);
  if (typeof vibe.lofiHissVolume === "number") {
    await send("lofi-hiss-volume", vibe.lofiHissVolume);
  }
  await send("lofi-tape-mode", !!vibe.lofiTapeMode);
  if (typeof vibe.rainVolume === "number") {
    await send("rain-volume", vibe.rainVolume);
  }
  await send("rainy-mode", !!vibe.rainyMode);
  if (typeof vibe.coffeeShopVolume === "number") {
    await send("coffee-shop-volume", vibe.coffeeShopVolume);
  }
  await send("coffee-shop-mode", !!vibe.coffeeShopMode);
  if (typeof vibe.seashoreVolume === "number") {
    await send("seashore-volume", vibe.seashoreVolume);
  }
  await send("seashore-mode", !!vibe.seashoreMode);
  if (typeof vibe.berghainVolume === "number") {
    await send("berghain-volume", vibe.berghainVolume);
  }
  await send("berghain-mode", !!vibe.berghainMode);
  if (typeof vibe.hotelLoungeVolume === "number") {
    await send("hotel-lounge-volume", vibe.hotelLoungeVolume);
  }
  await send("hotel-lounge-mode", !!vibe.hotelLoungeMode);
  if (typeof vibe.cocktailBarVolume === "number") {
    await send("cocktail-bar-volume", vibe.cocktailBarVolume);
  }
  await send("cocktail-bar-mode", !!vibe.cocktailBarMode);
  if (typeof vibe.vinylCrackleVolume === "number") {
    await send("vinyl-crackle-volume", vibe.vinylCrackleVolume);
  }
  await send("vinyl-crackle-mode", !!vibe.vinylCrackleMode);
  await send("preserve-pitch-mode", !!vibe.preservePitchMode);
  await send("video-fx", vibe.videoFx);

  try {
    return (
      (await sendMessageToTab(
        tabId,
        { command: "state" },
        { muteConnectionError: true },
      )) || latest
    );
  } catch (_error) {
    return latest;
  }
}
